import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

interface LoaderContextProps {
  isStartLoaderVisible: boolean;
  setIsStartLoaderVisible: (isStartLoaderVisible: boolean) => void;
  isMainLoaderVisible: boolean;
  mainLoaderText: string;
  isSceneLoaderVisible: boolean;
  isWhiteSceneLoaderVisible: boolean;
  setIsMainLoaderVisible: (isMainLoaderVisible: boolean) => void;
  setMainLoaderText: (mainLoaderText: string) => void;
  setIsSceneLoaderVisible: (isSceneLoaderVisible: boolean) => void;
  setIsWhiteSceneLoaderVisible: (isWhiteSceneLoaderVisible: boolean) => void;
}

const LoaderContext = createContext<LoaderContextProps | null>(null);

export const LoaderProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isStartLoaderVisible, setIsStartLoaderVisible] = useState(false);
  const [isMainLoaderVisible, setIsMainLoaderVisible] = useState(false);
  const [mainLoaderText, setMainLoaderText] = useState("");
  const [isSceneLoaderVisible, setIsSceneLoaderVisible] = useState(false);
  const [isWhiteSceneLoaderVisible, setIsWhiteSceneLoaderVisible] =
    useState(false);

  return (
    <LoaderContext.Provider
      value={{
        isStartLoaderVisible,
        isMainLoaderVisible,
        mainLoaderText,
        isSceneLoaderVisible,
        isWhiteSceneLoaderVisible,
        setIsStartLoaderVisible,
        setIsMainLoaderVisible,
        setMainLoaderText,
        setIsSceneLoaderVisible,
        setIsWhiteSceneLoaderVisible,
      }}
    >
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = (): LoaderContextProps => {
  const context = useContext(LoaderContext);

  if (!context) {
    throw new Error("useLoader must be used within a ViewProvider");
  }

  return context;
};
